import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import LinkButton from '../../../../../../components/LinkButton';
import ShowMore from '../../../../../../components/ShowMore';
import LinkBuilder from '../../../../../../helpers/link-builder';

const CommunicationMessageDialogBody = props => {
  const { message } = props;
  const {
    MessageID,
    Date,
    Subject,
    Recipients,
    From,
    Text,
    File,
    HasHtml,
  } = message;

  const [renderExcerpt, renderAll] = useMemo(
    () => [
      Recipients.slice(0, 3).map((person, index) => {
        return (
          <span className="communication-message__reciever" key={index}>
            {person}
            {index === Recipients.slice(0, 3).length - 1 ? '...  ' : ', '}
          </span>
        );
      }),
      Recipients.map((person, index) => {
        return (
          <span className="communication-message__reciever" key={index}>
            {person}
            {index === Recipients.length - 1 ? '' : ', '}
          </span>
        );
      }),
    ],
    [Recipients]
  );

  const attach = File
    ? LinkBuilder.getInboxAttachedFileLink(File, MessageID)
    : null;

  return (
    <div className="communication-message">
      <div className="communication-message__row">
        <div className="communication-message__date">{Date}</div>
      </div>
      <div className="communication-message__row">
        <div className="communication-message__meta">
          <div className="communication-message__direction">From: </div>
          <div className="communication-message__person">
            <span className="communication-message__sender">{From}</span>
          </div>
        </div>
      </div>
      <div className="communication-message__row">
        <div className="communication-message__direction">To: </div>
        {Recipients.length > 3 ? (
          <ShowMore renderExcerpt={renderExcerpt} renderAll={renderAll} />
        ) : (
          renderAll
        )}
      </div>

      <div className="communication-message__row">
        <span style={{ marginRight: '0.5em' }}>Subject:</span>
        <div className="communication-message__subject">{Subject}</div>
      </div>
      <div className="communication-message__text">
        {HasHtml === 'Yes' ? (
          <p
            className="communication-message__message"
            dangerouslySetInnerHTML={{ __html: Text }}
          />
        ) : (
          <p className="communication-message__message">{Text}</p>
        )}
      </div>
      {attach && (
        <div className="communication-message__attachments">
          <div className="communication-message__attachments-list">
            Attachments:
            <div className="communication-message__attachment">
              <LinkButton
                btnStyles={{
                  fontSize: '0.8571rem',
                  fontWeight: 400,
                }}
                text={File}
                link={attach}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

CommunicationMessageDialogBody.propTypes = {
  message: PropTypes.shape({
    MessageID: PropTypes.string,
    Date: PropTypes.string,
    Subject: PropTypes.string,
    Recipients: PropTypes.array,
    From: PropTypes.string,
    Text: PropTypes.string,
    File: PropTypes.string,
  }).isRequired,
};

export default CommunicationMessageDialogBody;
